
import { z } from "zod";

export const AddressKeySchemeValues = ["SMARTY_KEY", "CANONICAL_V1"] as const;
export const AddressKeySchemeSchema = /* @__PURE__ */ z.enum(AddressKeySchemeValues);
export const AddressKeyScheme: (typeof AddressKeySchemeSchema)["enum"] = { "SMARTY_KEY": "SMARTY_KEY", "CANONICAL_V1": "CANONICAL_V1" };
export type AddressKeyScheme = (typeof AddressKeySchemeValues)[number];
